import { gql } from '@apollo/client';
import { ORDER_REFERENCE_FIELDS } from '@/graphql/fragments/order_references';

export const INVOICE_EXPORT_ORDER_FIELDS = gql`
    ${ORDER_REFERENCE_FIELDS}

    fragment InvoiceExportOrderFields on orders {
        order_id
        created_at
        po_number
        delivery_date
        dropoff_zip
        order_type
        miles
        ltl_dropoff_arrival
        completion_time
        loading_completed
        ltl_pickup_completed
        references {
            ...OrderReferenceFields
        }
        itemsByOrderId {
            item_id
            sku
            quantity
            weight
            total_weight
            intangible
        }
    }
`;
